export const Axes = ({ width, height }) => {
  const ticks = [0, 0.1, 0.2, 0.3, 0.4, 0.6, 0.7, 0.8, 0.9, 1];
  const text = ['', 0.8, 0.6, 0.4, 0.2, -0.2, -0.4, -0.6, -0.8, ''];
  const horizLines = ticks.map((tick, i) => {
    const yPadding = tick === 1 ? 0 : 10;
    const position = (height + 10) * tick + yPadding;
    return (
      <g key={'line-' + i}>
        <line
          x1={10}
          x2={width + 10}
          y1={position}
          y2={position}
          stroke='#eeeeee'
        />
        {/* <text
          x={width / 2 + 12}
          y={position + 4}
          fill='#ababab'
          fontSize={13}
          textRendering={'optimizeLegibility'}
          dominantBaseline={'Auto'}
        >
          {text[index]}
        </text> */}
      </g>
    );
  });
  return (
    <g>
      {/* vertical and horizontal lines */}
      {horizLines}
      <line
        x1={10}
        x2={width + 10}
        y1={height / 2 + 10}
        y2={height / 2 + 10}
        stroke='#ababab'
        strokeDasharray='2'
      />
      <line
        x1={width / 2 + 10}
        x2={width / 2 + 10}
        y1={10}
        y2={height + 10}
        stroke='#ababab'
        strokeDasharray='2'
      />
    </g>
  );
};
